<template lang="pug">
  .component-backoffice-policy-list.row.column
    base-list(:component="component", :dataLoader="dataLoader", :showPerPageSelect="false",)
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import BaseList from './BaseList'
  import Role from '../../components/backoffice/Role'


  export default {
    name: 'RoleList',
    components: {
      Role,
      BaseList,
    },
    data: function () {
      return {
        component: require('src/components/backoffice/Role.vue'),
        roles: []
      }
    },
    created() {
      this.dataLoader()
    },
    methods: {
      dataLoader(callback, page, resultsPerPage) {
        KeplerBackofficeSdk.roles.list(page, resultsPerPage).all((data) => {
          callback(data)
        })
      }
    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// RoleList.vue?37d816ae